import 'core-js/stable';
import 'regenerator-runtime/runtime';
import raygun from 'raygun4js';
import { createRoot } from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license-pro';

import App from 'App';
import { getConfig } from 'config';

LicenseInfo.setLicenseKey(import.meta.env.MUI_X_PRO_KEY);

if (getConfig('REACT_APP_RAYGUN_ENABLED') === 'true') {
  raygun('apiKey', getConfig('REACT_APP_RAYGUN_KEY'));
  raygun('enableCrashReporting', true);
  raygun('enablePulse', true);
  raygun('withTags', ['react', getConfig('REACT_APP_ENVIRONMENT', 'unknown')]);
  raygun('options', {
    ignoreAjaxAbort: true,
    ignoreAjaxError: true,
    ignore3rdPartyErrors: true,
  });
}

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App />);
